import cn from 'classnames';
import { useMemo } from 'react';

import { Modal } from 'UIPackage/ModalModule/components/Modal';
import { ModalHeader } from 'UIPackage/ModalModule/components/ModalHeader';
import { ModalBody } from 'UIPackage/ModalModule/components/ModalBody';
import { ModalActions } from 'UIPackage/ModalModule/components/ModalActions';
import { Button } from 'UIPackage/MainModule/components/Button';
import { IKnmErknmFormViolatedRequirementsNpa } from 'KnmErknmPackage/MainModule/interfaces/IKnmErknmFormViolatedRequirementsNpa';
import { IKnmErknmFormRequirementNpa } from 'KnmErknmPackage/MainModule/interfaces/IKnmErknmFormRequirementNpa';

import styles from './NotifcationRepeatViolationModal.module.scss';
import { ViolationItem } from './ViolationItem';
import { ViolationStatusesEnum } from '../../../../APIPackage/KnmModule/enums/ViolationStatusesEnum';

interface INotificationRepeatViolationModalProps {
  requirementsNpa: IKnmErknmFormViolatedRequirementsNpa[] | undefined;
  requirementsCurrent: IKnmErknmFormRequirementNpa[] | undefined;
  visible: boolean;
  onClose: () => void;
  onSubmit: () => void;
}

export const NotificationRepeatViolationModal = ({
  requirementsNpa,
  requirementsCurrent,
  visible,
  onClose,
  onSubmit,
}: INotificationRepeatViolationModalProps) => {
  const handleSubmit = () => {
    onSubmit();
    onClose();
  };

  const getCountViolation = (npa: IKnmErknmFormViolatedRequirementsNpa[]) => {
    let count = 0;

    npa?.forEach(req => {
      req.violatedMandatory?.forEach(vm => {
        count += vm.violations?.length || 0;
      });
    });

    return count;
  };

  const getCountCurrentViolation = (npa: IKnmErknmFormRequirementNpa[]) => {
    let count = 0;

    npa?.forEach(req => {
      req.mandatory?.forEach(vm => {
        count += vm.violations?.length || 0;
      });
    });

    return count;
  };

  // Есть ли нарушения в статусе «Ожидает подтверждения»
  const hasApprovingRequirementsNpa = useMemo(() => {
    return (requirementsNpa || []).some(requirementNpa =>
      (requirementNpa?.violatedMandatory || []).some(mandatory =>
        (mandatory?.violations || []).some(violation => violation.status === ViolationStatusesEnum.APPROVING),
      ),
    );
  }, [requirementsNpa]);

  const isDisabledButtonNext =
    getCountViolation(requirementsNpa || []) === getCountCurrentViolation(requirementsCurrent || []);

  return (
    <Modal visible={visible} onClose={onClose}>
      <ModalHeader title="Уведомление об исключении нарушений из предмета проверки" sizeText="medium" />
      <ModalBody>
        <div className={styles.HelpWrapper}>
          {hasApprovingRequirementsNpa && (
            <div>
              <p>
                При подписании паспорта нарушения в статусе «Ожидает подтверждения» будут удалены из предмета проверки.{' '}
              </p>
              <p>
                Для возвращения в предмет мероприятия таких нарушений нажмите «Отмена» и оцените представленные
                материалы
              </p>
              <br />
            </div>
          )}

          <p>Нарушения, устранённые в ходе предыдущей проверки, удалены из повторной проверки автоматически.</p>
        </div>
        {requirementsNpa?.length && (
          <div className={styles.Table}>
            <div className={styles.Row}>
              <div className={cn(styles.Cell, styles.CellHeader, styles.PaddingLeftHeaderCell, styles.CellWidthStatus)}>
                СТАТУС
              </div>
              <div className={cn(styles.Cell, styles.CellHeader, styles.CellWidthDescription)}>ОПИСАНИЕ НАРУШЕНИЯ</div>
            </div>
            <div className={styles.BodyWrapper}>
              <div className={styles.Body}>
                {requirementsNpa?.map(requirementNpa => {
                  if (!requirementNpa.violatedMandatory || !requirementNpa.violatedMandatory?.length) return null;

                  return requirementNpa.violatedMandatory?.map(mandatory => {
                    if (!mandatory.violations) return null;

                    return mandatory.violations.map(violation => {
                      return (
                        <ViolationItem
                          key={violation.id}
                          violation={violation}
                          requirementNpa={requirementNpa}
                          mandatory={mandatory}
                        />
                      );
                    });
                  });
                })}
              </div>
            </div>
          </div>
        )}
      </ModalBody>
      <ModalActions>
        <div
          className={styles.ButtonsWrapper}
          style={{ justifyContent: isDisabledButtonNext ? 'space-between' : 'flex-end' }}
        >
          {isDisabledButtonNext && (
            <p className={styles.HelpTextRed}>Предмет мероприятия не может быть пустым. Все нарушения будут удалены.</p>
          )}
          <div>
            <Button
              text="Продолжить"
              color="primary"
              size="medium"
              onClick={handleSubmit}
              disabled={isDisabledButtonNext}
            />
            <Button text="Отмена" size="medium" onClick={onClose} />
          </div>
        </div>
      </ModalActions>
    </Modal>
  );
};
